// 7.2.2 IsArray(argument)
var cof = require('./_cof');
module.exports = Array.isArray || function isArray(arg) {
  return cof(arg) == 'Array';
};



//////////////////
// WEBPACK FOOTER
// /home/circleci/pickle/~/core-js/modules/_is-array.js
// module id = JI5q
// module chunks = 1